/* esm.sh - applesauce-common@5.2.0/dist/helpers/article */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/article.mjs";
